import { SVGAttributes } from "react";

const Neo3Icon = (props: SVGAttributes<SVGElement>) => {
  return (
    <svg
      viewBox="0 0 36 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="3"
        y="10"
        width="30"
        height="1"
        stroke="#FFA686"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="3"
        y="26"
        width="23"
        height="30"
        rx="5"
        transform="rotate(-90 3 26)"
        stroke="#CFB2FF"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 19H19"
        stroke="#FFA686"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25 19L26 19"
        stroke="#FFA686"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Neo3Icon;
